import {
  type BranchpointPlacement,
  type LabelPoint,
} from '../timelineDiagramLayout'
import { NodeDot } from './NodeDot'

// Hollow rings where lines meet the spine — one per branchpoint, plus one where
// the perspective tracks peel off. Drawn last so they sit cleanly atop the lines.
export const JunctionNodeDots = ({
  branchpoints,
  perspectiveForkNode,
}: {
  branchpoints: BranchpointPlacement[]
  perspectiveForkNode: LabelPoint | null
}) => (
  <g>
    {branchpoints.map(({ entry, node }) => (
      <NodeDot key={entry.detailsId} cx={node.x} cy={node.y} />
    ))}
    {perspectiveForkNode && (
      <NodeDot cx={perspectiveForkNode.x} cy={perspectiveForkNode.y} r={4.5} />
    )}
  </g>
)
